<template>
  <div>
    <h1 class="page-title">Documents</h1>
    <p>In order to use this application you need to accept these documents</p>
    <v-dialog
      v-model="dialog[document.id]"
      v-bind:key="document.id"
      v-for="document in compulsoryDocuments"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
          {{ document.title }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ document.title }}
        </v-card-title>
        <v-card-text>
          <v-btn
            v-if="document.file"
            :href="documentsDownloadAPI + document.id + '/download/'"
          >
            <v-icon> mdi-cloud-download </v-icon>
          </v-btn>
          <v-spacer v-if="document.file"></v-spacer>
          <p>{{ document.text }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog[document.id] = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-expansion-panels popout>
      <v-expansion-panel
        v-bind:key="document.id"
        v-for="document in compulsoryDocuments"
      >
        <v-expansion-panel-header>
          {{ document.title }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-btn
            v-if="document.file"
            :href="documentsDownloadAPI + document.id + '/download/'"
          >
            <v-icon> mdi-cloud-download </v-icon>
          </v-btn>
          <v-spacer v-if="document.file"></v-spacer>
          <p>{{ document.text }}</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
    <v-form ref="form" v-model="valid" class="glass-element" lazy-validation>
      <TinyLoaderLight v-if="loading" />
      <v-btn v-else @click="addDocumentsToProfile" class="form-actions">
        Accept all documents
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";
import { profileGetMiscellaneousIdsList } from "@/utils/profiles.util";

export default {
  components: { TinyLoaderLight },
  data() {
    return {
      loading: false,
      valid: false,
      dialog: {},
    };
  },
  computed: mapState({
    documentsDownloadAPI: () =>
      process.env.VUE_APP_API_URL + "documentsdownload/",
    ownProfile: (state) => state.profiles.ownProfile,
    compulsoryDocuments: (state) => state.documents.compulsoryDocuments,
    documents() {
      return this.compulsoryDocuments.map((e) => e.id);
    },
  }),
  mounted() {
    this.dialog = {};
    this.$store.commit("RESET_PROFILES");
    this.$store.dispatch("getOwnProfile");
    this.$store.dispatch("getCompulsoryDocuments").then(() => {
      for (const document of this.documents) {
        this.dialog[document.id] = false;
      }
    });
  },
  methods: {
    async addDocumentsToProfile() {
      this.loading = true;
      this.ownProfile = profileGetMiscellaneousIdsList(this.ownProfile);
      this.ownProfile.accepted_documents.push(...this.documents);
      await this.$store
        .dispatch("updateProfile", this.ownProfile)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("getOwnProfile");
          this.$router.push("/");
        });
    },
  },
};
</script>

<style scoped>
.doc-div {
  float: left;
  margin: 5px;
}
</style>